import React from 'react'
import Filtro from '../comum/Filtro'
import FiltrosAdicionadosRotas from './FiltrosAdicionadosRotas'
import FiltroRotas from './FiltroRotas'
import PainelFiltragem from '../comum/PainelFiltragem'

export const PainelFiltroRotas = () => (
  <Filtro PainelFiltro={FiltroRotas}/>
);

const PainelFiltrosRotas = () => (
  <PainelFiltragem
    Filtro={PainelFiltroRotas}
    FiltrosAdicionados={FiltrosAdicionadosRotas}/>
)

export default PainelFiltrosRotas
